import React from 'react';
import classnames from 'classnames';
import { PapiUser } from '@wix/da-papi-types';
import UserAvatar from '../User/Avatar/index';
import UserLink from '../User/Link/index';
import s from './ProfileIdentityMobile.scss';

export interface Props {
  tagline?: string;
  className?: string;
  user: PapiUser;
  statsComponent: React.ReactNode;
  centered?: boolean;
}

export class ProfileIdentityMobile extends React.PureComponent<Props> {
  render() {
    const { className, user, tagline, statsComponent, centered } = this.props;
    return (
      <div className={classnames(s['root'], className, centered && s['centered'])}>
        <UserAvatar size={80} user={user} className={s['user-avatar']} />
        <div className={s['user-details']}>
          <h1 className={s['user-link']}>
            <UserLink
              className={s['user-link-text']}
              symbolClassName={s['user-link-icon']}
              user={user}
            />
          </h1>
          {tagline && <div className={s['user-label']}>{tagline}</div>}
          {statsComponent}
        </div>
      </div>
    );
  }
}

export default ProfileIdentityMobile;
